const loadpage = ({ commit }) => commit('LOADPAGE')
const appInstance = ({ commit }, instance) => commit('APPINSTANCE', instance)
const imageToView = ({ commit }, prevent) => commit('IMAGETOVIEW', prevent)
const productImageToView = ({ commit }, images) =>
  commit('PRODUCTIMAGETOVIEW', images)
const messageData = ({ commit }, data) => commit('MESSAGEDATA', data)
const keepPageState = ({ commit }, pageState) =>
  commit('KEEPPAGESTATE', pageState)
const setOrientation = ({ commit }, orientation) =>
  commit('SETORIENTATION', orientation)

export default {
  loadpage,
  appInstance,
  setOrientation,
  keepPageState,
  imageToView,
  messageData,
  productImageToView
}
